import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class StarlinkApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }

  Get_ServiceLines (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/starlink/servicelines`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_DataUsage (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/starlink/datausage`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }
}
